"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyCharacterDecoder = void 0;
var tslib_1 = require("tslib");
var character_decoder_1 = require("./character-decoder");
var EmptyCharacterDecoder = (function (_super) {
    tslib_1.__extends(EmptyCharacterDecoder, _super);
    function EmptyCharacterDecoder() {
        return _super.call(this) || this;
    }
    EmptyCharacterDecoder.prototype.processChar = function (importer, ch) {
        importer.destination.processChar(ch);
    };
    EmptyCharacterDecoder.prototype.flush = function (_importer) {
    };
    return EmptyCharacterDecoder;
}(character_decoder_1.CharacterDecoder));
exports.EmptyCharacterDecoder = EmptyCharacterDecoder;
